module.exports = __webpack_public_path__ + "static/img/05f5a10a9e578b93e0e99b24ae015b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_active_05.png
// module id = xI+f
// module chunks = 1